// The following eslint-disable was automated from the ts conversion
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* @ts-expect-error auto-src: noflow */
export default function nameFromField(nativeElement) {
  return nativeElement.getAttribute('name').match(/user\[([^]+)\]/)[1]
}
